<mat-card style="border-color: #5775a8;">
  <mat-card-header class="">
    <div class="flex flex-row rounded-lg w-full" style="background-color:#5775a8; padding: 20px;">
      <mat-icon style="color: white;">settings</mat-icon>
      <span style="font-size: large; color: white;">
        Administration
      </span>
    </div>
  </mat-card-header>

  <mat-card-content>
    <div class="flex flex-col items-center">
      <div class="flex flex-col w-11/12">
        <br />
        <div class="flex flex-row">
          <a (click)="gotoPage('users')">Users</a>
        </div>
        <div class="flex flex-row">
          <a (click)="gotoPage('businessAdmin')">Business Admin</a>
        </div>
        <div class="flex flex-row">
          <a (click)="gotoPage('complaintAdmin')">Complaint Admin</a>
        </div>
        <div class="flex flex-row">
          <a (click)="gotoPage('emailAdmin')">Email Admin</a>
        </div>
        <div *ngIf="isDev" class="flex flex-row">
          <a (click)="gotoPage('roles')">Roles</a>
        </div>
      </div>
    </div>

  </mat-card-content>
</mat-card>